import * as React from "react";
import { appStore } from "src/appStore";
import { getLangName } from "src/types/ZLanguageProps";
import { AttrData } from "../AttributeHistrory.types";

export const AttrLanguage: React.FC<AttrData> = ({ value }) => {
  const lang = appStore.contentLangMap[value];
  return lang ? getLangName(lang) : value;
};
